// extracted by mini-css-extract-plugin
export default {"container":"h2-z","list":"i2-z"};